import { apiClient } from "./apiClient";

export const priceService = {
  getCreditPrice: async (product) => {
    try {
      const response = await apiClient.get(`/prices/credit-price?product=${product}`);
      return response.data;
    } catch (error) {
      console.error("Error getting credit price:", error);
      return { price: "⁉️", error: "Error getting credit price" };
    }
  },

  updatePrice: async (product, price) => {
    try {
      const response = await apiClient.post("/admin/prices/update-price", { product, price });
      return response.data;
    } catch (error) {
      console.error("Error updating price:", error);
      return { price: "⁉️", error: "Error updating price" };
    }
  },

  updateCreditsForPrice: async (product, credits) => {
    try {
      const response = await apiClient.post("/admin/prices/update-credits-for-price", {
        product,
        credits,
      });
      return response.data;
    } catch (error) {
      console.error("Error updating credits for price:", error);
    }
  },

  getOneTimeAccessPrice: async () => {
    try {
      const response = await apiClient.get("/prices/one-time-access");
      return response.data;
    } catch (error) {
      console.error("Error getting one-time access price:", error);
      return { price: "⁉️", error: "Error getting one-time access price" };
    }
  },
};
